export default __webpack_public_path__ + "static/media/awards.d98bfee7.jpg";